module.exports = __webpack_public_path__ + "img/oval_head_sku.prt.3022f12b.jpg";